import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
    state: false,
    id : [],
};
const selectedRawData = createSlice({
    name: 'rawData',
    initialState: initialState,
    reducers: {
        addRawData: (state: any, action: PayloadAction<string[]>) => {
            state.state = true;
            state.id = action.payload;
        },
    }
});

export const { addRawData } = selectedRawData.actions;

export default selectedRawData.reducer;
